export default __webpack_public_path__ + "alberta-breath-therapy.02d1287f46e91f43fb91.svg";